import AddAcronisBackupSettings from './Add';

export default AddAcronisBackupSettings;
